(function () {
  const initCountrySelector = (section) => {
    const localization = section?.querySelector('#FooterCountryForm');
    const button = localization?.querySelector('[aria-controls="FooterCountryList"]');
    const list = localization?.querySelector('[data-footer-country-list]');
    const data = localization?.querySelector('[data-footer-country-options]');
    const input = localization?.querySelector('input[name="country_code"]');

    if (!localization || !button || !list || !data || !input) return;
    if (localization.dataset.footerCountryInitialized === "true") return;
    localization.dataset.footerCountryInitialized = "true";

    const populateCountries = () => {
      if (list.childElementCount) return;

      let countries;
      try {
        countries = JSON.parse(data.textContent);
      } catch (error) {
        console.error("Unable to initialize footer countries", error);
        return;
      }

      const fragment = document.createDocumentFragment();

      countries.forEach((country) => {
        const active = country.code === input.value;
        const item = document.createElement("li");
        item.className =
          "disclosure__item" + (active ? " disclosure__item--active" : "");
        item.tabIndex = -1;

        const link = document.createElement("a");
        link.className =
          "link link--text disclosure__link body-small caption-large" +
          (active ? " disclosure__link--active" : "") +
          " focus-inset";
        link.href = "#";
        link.dataset.value = country.code;
        if (active) link.setAttribute("aria-current", "true");

        if (country.flag) {
          const flag = document.createElement("span");
          const image = document.createElement("img");
          flag.className = "currency-flag";
          flag.setAttribute("aria-hidden", "true");
          image.className = "currency-flag-img";
          image.src = country.flag;
          image.alt = "";
          image.width = 40;
          image.loading = "lazy";
          image.decoding = "async";
          flag.appendChild(image);
          link.appendChild(flag);
        }

        const name = document.createElement("span");
        name.className = "disclosure__country-name";
        name.textContent = country.name;

        const currency = document.createElement("span");
        currency.className = "localization-form__currency";
        currency.textContent =
          " (" + country.currency + " " + country.symbol + ")";

        link.append(name, currency);
        item.appendChild(link);
        fragment.appendChild(item);
      });

      list.appendChild(fragment);
      data.remove();
    };

    button.addEventListener("click", populateCountries, {
      capture: true,
      once: true,
    });

    localization.addEventListener("click", (event) => {
      const option = event.target.closest("a[data-value]");
      if (!option || !localization.contains(option)) return;

      event.preventDefault();
      input.value = option.dataset.value;
      localization.querySelector("form")?.submit();
    });
  };

  const initFooter = (section) => {
    if (!section) return;

    initCountrySelector(section);

    if (document.documentElement.getAttribute("dir") === "rtl") return;

    const positionCheckbox = (inputContainer, inputWrapper, checkbox) => {
      const containerLeft = inputContainer.getBoundingClientRect().left;
      const inputLeft = inputWrapper.getBoundingClientRect().left;
      const diff = inputLeft - containerLeft;
      checkbox.style.paddingLeft = diff + "px";
    };

    const inputContainer = section.querySelector(
      ".footer-subscribe-form__main"
    );
    const inputWrapper = section.querySelector(
      ".footer-subscribe-form__input-wrapper"
    );
    const checkbox = section.querySelector(".footer-subscribe-form-checkbox");

    if (inputContainer && inputWrapper && checkbox) {
      let sectionWidth = section.getBoundingClientRect().width;
      const observer = new ResizeObserver((entries) => {
        if (entries[0].contentRect.width !== sectionWidth) {
          positionCheckbox(inputContainer, inputWrapper, checkbox);
          sectionWidth = entries[0].contentRect.width;
        }
      });

      const startObserver = () => {
        positionCheckbox(inputContainer, inputWrapper, checkbox);
        observer.observe(section);
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", startObserver, {
          once: true,
        });
      } else {
        startObserver();
      }
    }
  };

  initFooter(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initFooter(event.target);
  });
})();
